"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Serviceareas() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: panelRef,
    isVisible: panelVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const routes = [{
    dest: "DES MOINES, IA",
    miles: "LOCAL",
    freq: "DAILY"
  }, {
    dest: "WEST DES MOINES, IA",
    miles: "8 MI",
    freq: "DAILY"
  }, {
    dest: "ANKENY, IA",
    miles: "12 MI",
    freq: "DAILY"
  }, {
    dest: "URBANDALE, IA",
    miles: "10 MI",
    freq: "DAILY"
  }, {
    dest: "WAUKEE, IA",
    miles: "15 MI",
    freq: "DAILY"
  }, {
    dest: "JOHNSTON, IA",
    miles: "11 MI",
    freq: "DAILY"
  }, {
    dest: "ALTOONA, IA",
    miles: "14 MI",
    freq: "WEEKLY"
  }, {
    dest: "GRIMES, IA",
    miles: "16 MI",
    freq: "WEEKLY"
  }, {
    dest: "CLIVE, IA",
    miles: "9 MI",
    freq: "DAILY"
  }, {
    dest: "PLEASANT HILL, IA",
    miles: "7 MI",
    freq: "WEEKLY"
  }, {
    dest: "INDIANOLA, IA",
    miles: "18 MI",
    freq: "ON REQUEST"
  }, {
    dest: "NORWALK, IA",
    miles: "12 MI",
    freq: "WEEKLY"
  }, {
    dest: "POLK CITY, IA",
    miles: "19 MI",
    freq: "ON REQUEST"
  }, {
    dest: "BONDURANT, IA",
    miles: "15 MI",
    freq: "WEEKLY"
  }, {
    dest: "CARLISLE, IA",
    miles: "13 MI",
    freq: "ON REQUEST"
  }];
  const stats = [{
    label: "RESPONSE TIME",
    value: "2 HRS"
  }, {
    label: "LOCAL CREWS",
    value: "6"
  }, {
    label: "HOMES PROTECTED",
    value: "500+"
  }];
  return <section data-section-id="1667" id="serviceareas" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute right-4 md:right-12 top-1/2 -translate-y-1/2 select-none font-serif font-light leading-none text-primary opacity-[0.05]" style={{
      fontSize: "28vw"
    }}>
        IA
      </div>

      <div className="relative mx-auto w-full max-w-[1440px] px-6 md:px-12 lg:px-[88px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div ref={headerRef} className={`lg:col-span-8 transition-all duration-[800ms] ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
        }}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="font-mono text-[0.75rem] uppercase tracking-[0.18em] text-primary">
                § 02 / SERVICE AREA — GREATER DES MOINES
              </span>
            </div>

            {}
            <div className="flex items-center mb-10" aria-hidden="true">
              <span className="block h-px w-20 bg-primary" />
              <span className="block h-1 w-1 bg-primary ml-0" />
            </div>

            {}
            <h2 className="font-default font-bold text-foreground leading-[1.0] tracking-tight mb-8" style={{
            fontSize: "clamp(2.25rem, 5.4vw, 4.75rem)",
            letterSpacing: "-0.02em"
          }}>
              Where We{" "}
              <span className="italic text-primary">Work</span>
            </h2>

            {}
            <p className="font-default text-foreground/85 max-w-2xl mb-14 leading-relaxed" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)"
          }}>
              Based in Des Moines, serving the entire metro area. We provide expert crawl space solutions to homeowners across Central Iowa.
            </p>

            {}
            <div className="hidden md:grid grid-cols-12 gap-4 pb-3 border-b border-border mb-2">
              <div className="col-span-7 font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted-foreground">
                Community
              </div>
              <div className="col-span-3 font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted-foreground">
                Distance
              </div>
              <div className="col-span-2 font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted-foreground text-right">
                Availability
              </div>
            </div>

            {}
            <div className="flex flex-col">
              {routes.map((route, i) => <div data-index={i} key={i} className="group relative grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 py-4 border-b border-border transition-colors duration-300 hover:bg-accent cursor-default">
                  <div className="md:col-span-7 flex items-center gap-3">
                    <span className="font-mono text-[0.7rem] text-primary/60 uppercase tracking-[0.15em]">
                      DSM →
                    </span>
                    <span className="font-default font-semibold text-foreground text-base md:text-[0.95rem] tracking-wide">
                      {route.dest}
                    </span>
                  </div>
                  <div className="md:col-span-3 flex items-center">
                    <span className="font-mono text-sm text-primary tracking-[0.08em] transition-colors duration-300 group-hover:text-secondary">
                      {route.miles}
                    </span>
                  </div>
                  <div className="md:col-span-2 flex items-center md:justify-end">
                    <span className="font-mono text-[0.7rem] uppercase tracking-[0.16em] text-muted-foreground">
                      {route.freq}
                    </span>
                  </div>

                  {}
                  <div aria-hidden="true" className="pointer-events-none absolute left-0 bottom-0 flex items-center">
                    <span className="block h-px bg-primary w-0 group-hover:w-24 transition-all duration-[250ms] ease-out" />
                    <span className="block h-1 w-1 bg-primary opacity-0 group-hover:opacity-100 transition-opacity duration-[250ms]" />
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div ref={panelRef} className={`lg:col-span-4 transition-all duration-[800ms] ease-out ${panelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)",
          transitionDelay: "120ms"
        }}>
            <div className="lg:sticky lg:top-28 flex flex-col gap-10">
              {}
              <div className="relative border border-border p-8 transition-colors duration-300 hover:border-primary rounded-md shadow-md" style={{
              backgroundColor: "var(--card)"
            }}>
                {}
                <span aria-hidden="true" className="absolute top-2 left-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-primary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-primary" />
                </span>
                <span aria-hidden="true" className="absolute top-2 right-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-primary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-primary" />
                </span>
                <span aria-hidden="true" className="absolute bottom-2 left-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-primary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-primary" />
                </span>
                <span aria-hidden="true" className="absolute bottom-2 right-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-primary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-primary" />
                </span>

                <div className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-primary mb-6">
                  § 02.A / INSPECTION
                </div>

                <h3 className="font-default font-bold text-foreground mb-4 leading-[1.15]" style={{
                fontSize: "clamp(1.5rem, 2.6vw, 2.25rem)",
                letterSpacing: "-0.015em"
              }}>
                  Outside the <span className="italic text-primary">Metro?</span>
                </h3>

                <p className="font-default text-muted-foreground text-[0.9375rem] leading-[1.65] mb-8">
                  We frequently travel for larger encapsulation projects across Central Iowa. Contact us for a custom quote.
                </p>

                <Button asChild className="w-full h-auto rounded-md bg-primary text-primary-foreground hover:bg-secondary px-7 py-4 font-mono text-[0.78rem] uppercase tracking-[0.16em] transition-all duration-300 shadow-sm">
                  <Link to="/ContactPage">
                    Request Free Inspection
                  </Link>
                </Button>
              </div>

              {}
              <div className="flex flex-col">
                <div className="flex items-center mb-6" aria-hidden="true">
                  <span className="block h-px w-12 bg-primary" />
                  <span className="block h-1 w-1 bg-primary" />
                </div>
                <div className="flex flex-col gap-6">
                  {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-baseline justify-between border-b border-border pb-4">
                      <span className="font-mono text-[0.72rem] uppercase tracking-[0.18em] text-muted-foreground">
                        {stat.label}
                      </span>
                      <span className="font-mono text-base md:text-lg text-primary tracking-[0.08em]">
                        / {stat.value}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}